import { render, staticRenderFns } from "./CRInput.vue?vue&type=template&id=3acbc5d4&scoped=true"
import script from "./CRInput.vue?vue&type=script&lang=js"
export * from "./CRInput.vue?vue&type=script&lang=js"
import style0 from "./CRInput.vue?vue&type=style&index=0&id=3acbc5d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acbc5d4",
  null
  
)

export default component.exports